<template>
  <div class="container">
    <custom-select
      label="Nacionalidad"
      :value="value"
      :name="name"
      @input="onChange"
      @click="$emit('click')"
      @onFocus="$emit('onFocus')"
      :items="nacionalidades"
      :quantumObfuscate="quantumObfuscate"
    />
  </div>
</template>

<script>
import { nacionalidades } from "@/config/constants/index";
import CustomSelect from "@/components/core/custom/CustomSelect";
export default {
  name: "CountrySelector",
  components: { CustomSelect },
  props: {
    value: String,
    name: String,
    esExtranjero: Boolean,
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      extranjeros: nacionalidades.slice(1)
    };
  },
  computed: {
    nacionalidades() {
      return this.esExtranjero ? this.extranjeros : nacionalidades;
    }
  },
  methods: {
    onChange(val) {
      this.$emit("input", val);
    }
  },
  watch: {
    /**
     * Escuchar el prop esExtranjero.
     * Si cambia a TRUE cambiamos la nacionalidad por defecto para que ésta no sea Argentina
     */
    esExtranjero: function(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        // Seleccionamos la nacionalidad a la primera que no sea Argentina
        this.$emit("input", this.extranjeros[0].value);
      } else {
        // Volvemos al valor por defecto (Argentina)
        this.$emit("input", nacionalidades[0].value);
      }
    }
  }
};
</script>
